function formatLocalYmd(d: Date) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
}

/**
 * Etiqueta de versión web: fecha de build (YYYY.MM.DD) + v{n} con n entero incremental.
 * Ej.: 2026.05.11 v3 — generada en Vite (package.json webBuild o env WEB_BUILD_NUMBER).
 */
export const APP_WEB_VERSION =
  typeof __APP_VERSION__ !== 'undefined' && __APP_VERSION__
    ? __APP_VERSION__
    : `${formatLocalYmd(new Date())} v1`;

/** Solo la parte `vn` / `v{n}` (drawer colapsado). */
export const APP_WEB_VERSION_COMPACT = (() => {
  const m = APP_WEB_VERSION.match(/^\d{4}\.\d{2}\.\d{2} (.+)$/);
  return m ? m[1] : APP_WEB_VERSION;
})();
